export const HOME = {
  emergentLink: "emergent-link",
};

export const BD = {
  nav: "bd-nav",
  navLogo: "bd-nav-logo",
  navMobileToggle: "bd-nav-mobile-toggle",
  langSwitch: "bd-lang-switch",
  heroCtaSolutions: "bd-hero-cta-solutions",
  heroCtaEisg: "bd-hero-cta-eisg",
  contactForm: "bd-contact-form",
  contactFormSubmit: "bd-contact-form-submit",
  contactName: "bd-contact-name",
  contactEmail: "bd-contact-email",
  contactOrg: "bd-contact-org",
  contactSubject: "bd-contact-subject",
  contactMessage: "bd-contact-message",
  footer: "bd-footer",
};

export const EISG = {
  nav: "eisg-nav",
  navLogo: "eisg-nav-logo",
  navMobileToggle: "eisg-nav-mobile-toggle",
  navBackBd: "eisg-nav-back-bd",
  heroCtaProgrammes: "eisg-hero-cta-programmes",
  heroCtaCatalogue: "eisg-hero-cta-catalogue",
  heroCtaPreinscription: "eisg-hero-cta-preinscription",
  catalogueDialog: "eisg-catalogue-dialog",
  catalogueDialogSubmit: "eisg-catalogue-dialog-submit",
  catalogueDialogName: "eisg-catalogue-name",
  catalogueDialogEmail: "eisg-catalogue-email",
  catalogueDialogOrg: "eisg-catalogue-org",
  catalogueDialogCountry: "eisg-catalogue-country",
  whatsappBtn: "eisg-whatsapp-btn",
  programmeCardPhare: "eisg-prog-card-phare",
  programmeCardCommand: "eisg-prog-card-command",
  programmeCardAugmentees: "eisg-prog-card-augmentees",
  registrationForm: "eisg-registration-form",
  registrationSubmit: "eisg-registration-submit",
  regName: "eisg-reg-name",
  regFunction: "eisg-reg-function",
  regOrg: "eisg-reg-org",
  regCountry: "eisg-reg-country",
  regEmail: "eisg-reg-email",
  regPhone: "eisg-reg-phone",
  regProgramme: "eisg-reg-programme",
  regSession: "eisg-reg-session",
  regParticipants: "eisg-reg-participants",
  regNeeds: "eisg-reg-needs",
  regComments: "eisg-reg-comments",
  contactForm: "eisg-contact-form",
  contactSubmit: "eisg-contact-submit",
  footer: "eisg-footer",
};
